import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'gwx-fetch';
import { parse } from 'query-string';
import {
	loadCommunityContext, Application, LoadingIndicator, Route, Switch, Redirect, connectedComponent, loadCommunities, loadCommunityIdsByEmail, ErrorPage
} from 'gwx-voyager-components';

import Reports from '../Reports/Reports.react';
import Reporting from '../Reporting/Reporting.react';
import ApplicationSidebar from '../ApplicationSidebar/ApplicationSidebar.react';
import ApplicationFooter from '../ApplicationFooter/ApplicationFooter.react';
import Opportunities from  '../OpportunityQueue/Opportunities.react';
import Subscriptions from '../Subscription/Subscriptions.react';
import SendingFacility from '../Administration/SendingFacility.react';
import InvalidContext from './InvalidContext.react';
import ProfileContainer from '../Profile/Profile.react';
import ClientInvitations from '../ClientInvitations/ClientInvitations.react';
import { receiveOpportunityCount } from '../OpportunityQueue/opportunities.action';
import { loadProfile } from '../Profile/profile.actions';
import { parseAttributes, profileName } from '../Profile/ProfileUtils';
import './app.scss';

class App extends Component {
	constructor(props) {
		super(props);
		this.checkStatus = this.checkStatus.bind(this);
		this.loadContextRetry = this.loadContextRetry.bind(this);
		this.state = {
			forbidden: false
		};
	}

	UNSAFE_componentWillMount() {
		this.loadContextRetry(this.props.context.id).then(this.checkStatus);
		this.props.fetchOpportunitiesCount(this.props.context.id);
		this.props.fetchCommunities(this.props.query);
		this.props.fetchCommunityIdsByEmail();
		this.props.fetchProfile(this.props.profileId);
	}
	
	loadContextRetry(id) {
	    return new Promise((resolve, reject) => {
	        this.props.loadContext(id)
	            .then((result) => 
	                /* on success */
	                resolve(result)
	            )
	            .catch((error) => {
	                /* on failure */
	                this.loadContextRetry(id)
	                    .then((result) => resolve(result))
	                    .catch((error) => reject(error));
	            })
	    });
}

	shouldComponentUpdate(nextProps) {
		if (JSON.stringify(nextProps.context.id) !== JSON.stringify(this.props.context.id)) {
			this.props.loadContext(nextProps.context.id).then(this.checkStatus);
			this.props.fetchOpportunitiesCount(nextProps.context.id);
			return false;
		}

		if (JSON.stringify(nextProps.pathname) !== JSON.stringify(this.props.pathname)) {
			this.props.fetchOpportunitiesCount(nextProps.context.id);
		}

		return true;
	}

	checkStatus(response) {
		let forbidden = false;
		const exception = response.error;
		if (undefined !== exception && exception.status === 403) {
			forbidden = true;
		}
		this.setState({ forbidden });
	}

	render() {
		const hasCommunitiesToShowExchange = this.props.communitiesCount > 1;
		const forbiddenMsgHeading = 'Forbidden Community';
		const forbiddenMsgDetails = 'You are not authorized to view this community. Contact Cerner Support for more information.';

		const attributes = parseAttributes(this.props.profile, this.props.profileId);

		if (this.props.context.isFetching) {
			return <LoadingIndicator />;
		}

		if (!this.props.context.isFetching && this.state.forbidden) {
			return <ErrorPage heading={forbiddenMsgHeading} details={forbiddenMsgDetails} />;
		}

		if (!this.props.context.isFetching && !this.props.context.community) {
			return <InvalidContext id={this.props.context.id} />;
		}

		return (
			<Application
				sidebar={(
					<ApplicationSidebar
						activePath={this.props.pathname}
						context={this.props.context.id}
						opportunityCount={this.props.opportunityCount}
						profileId={this.props.profileId}
						invitationEnabled={this.props.invitationEnabled}
					/>
				)}
				footer={<ApplicationFooter />}
				timeout={{delay: this.props.timeout}}
				navigation={{
					brand: {
						setExchange: false, brandUrl: '/', alternateBrandClass: 'hasExchange', brandName: this.props.context.community.name, brandIconName: 'id-badge', brandClass: 'brand-name', brandImgAlt: this.props.context.community.name
					},
					navigationRight: [{ type: 'dropdown', display: profileName(attributes, this.props.username), options: [{ href: `/profile/${this.props.profileId}`, display: 'Profile' }, { href: this.props.helpLink, display: 'Help', target: '_blank' }, { href: this.props.logoutLink, display: 'Logout' }] }],
					communityNavBrand: {
						setExchange: hasCommunitiesToShowExchange, brandIconExchangeName: 'exchange', brandClass: 'brand-name-exchange', brandUrl: '/'
					}
				}}
			>
				<Switch>
					<Route path='/:id/reports' component={Reports} />
					<Route
						path='/:id/subscriptions'
						component={Subscriptions}
					/>
					<Route
						path='/:id/opportunities'
						component={Opportunities}
					/>
					<Route
						path='/:id/reporting'
						component={Reporting}
					/>
					<Route
						path='/:id/administration'
						component={SendingFacility}
					/>
					<Route
						path='/:id/clientInvitations'
						component={ClientInvitations}
					/>
					<Route
						path='/:id/profile/:profileId'
						component={ProfileContainer}
					/>
					<Redirect to='/pageNotFound' />
				</Switch>
			</Application>
		);
	}
}
App.defaultProps = {
	opportunityCount: null,
	helpLink: window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls && window.gwx.ui.props.urls.help,
	logoutLink: (window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls && window.gwx.ui.props.urls.logout) || '/logout',
	username: (window.gwx && window.gwx.ui && window.gwx.ui.username) || 'User',
	profileId: window.gwx && window.gwx.ui && window.gwx.ui.profileId,
	timeout: (window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.timeout),
	communitiesCount: 0,
	profile: null
};
App.propTypes = {
	context: PropTypes.shape({
		isFetching: PropTypes.bool.isRequired,
		id: PropTypes.string.isRequired,
		community: PropTypes.shape({
			name: PropTypes.string,
			id: PropTypes.string
		})
	}).isRequired,
	communitiesCount: PropTypes.number,
	loadContext: PropTypes.func.isRequired,
	pathname: PropTypes.string.isRequired,
	opportunityCount: PropTypes.number,
	fetchOpportunitiesCount: PropTypes.func.isRequired,
	helpLink: PropTypes.string,
	logoutLink: PropTypes.string,
	username: PropTypes.string,
	profileId: PropTypes.string,
	fetchCommunities: PropTypes.func.isRequired,
	fetchCommunityIdsByEmail: PropTypes.func.isRequired,
	fetchProfile: PropTypes.func.isRequired,
	profile: PropTypes.shape({
		id: PropTypes.string,
		attributes: PropTypes.arrayOf(PropTypes.string)
	})
};

const mapStateToProps = (state, props) => {
	const {
		match: { params: { id } },
		location: { pathname }
	} = props;

	const {
		entities: { community, communities, profile, communityIdsByEmail }
	} = state;

	let communityIds = [];
	Object.keys(communityIdsByEmail.ids)
		.map((id) => communityIds.push(communityIdsByEmail.ids[id]));
		
	return {
		context: {
			id,
			isFetching: community.isFetching,
			community: community[id]
		},
		pathname,
		query: { size: '256', number: '0', ...parse(props.location.search) },
		opportunityCount: state.opportunityCount || null,
		communitiesCount: (communities.ids
			.map((id) => communities.results[id])).length,
		profile,
		invitationEnabled: communityIds.includes(id)
	};
};

const mapDispatchToProps = (dispatch) => ({
	fetchCommunities: (query) => dispatch(loadCommunities(query)),

	fetchCommunityIdsByEmail: () => dispatch(loadCommunityIdsByEmail()),
	/**
	 * Makes a fetch request for the list of sending facilities.
	 */
	loadContext: (id) => dispatch(loadCommunityContext(id)),
	/**
	 * Makes a fetch request for a count of opportunities.
	 */
	fetchOpportunitiesCount: (communityId) => get(`/api/opportunities?communityId=${communityId}&count=true`)
		.then((count) => dispatch(receiveOpportunityCount(count)))
		.catch(res => {
			if (res.status === 403) {
				let intervalId = setInterval(() => {
					get(`/api/opportunities?communityId=${communityId}&count=true`)
						.then((count) => dispatch(receiveOpportunityCount(count)))
				}, 3000);
				setTimeout(() => clearInterval(intervalId), 10000);
			}
		}),
	/**
	 * Makes a fetch request for the profile.
	 * @param {*} id profile id
	 * @returns The profile object
	 */
	 fetchProfile: (id) => dispatch(loadProfile(id))
});

export default connectedComponent(App,
	mapStateToProps,
	mapDispatchToProps, false);
